import $ from 'jquery';

const cookieConsent = {
  init: function() {
    $('[data-cookie-consent]').on('click', function() {
      var expDate = new Date();
      expDate.setTime(expDate.getTime() + (7 * 24 * 60 * 60 * 1000)); // 1 week
      document.cookie = 'cookieConsent=1;expires=' + expDate.toUTCString() + ';path=/';

      $(this).closest('[data-cookie-consent-parent]').slideUp();
    });
  }
};

export default cookieConsent;
